var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLedger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#E6E6E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1184_1569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 20.6667H10.6667C10.4899 20.6667 10.3203 20.5964 10.1953 20.4714C10.0702 20.3464 10 20.1768 10 20V10.6667C10 10.4899 10.0702 10.3203 10.1953 10.1953C10.3203 10.0702 10.4899 10 10.6667 10H14.6667C15.0203 10 15.3594 10.1405 15.6095 10.3905C15.8595 10.6406 16 10.9797 16 11.3333C16 10.9797 16.1405 10.6406 16.3905 10.3905C16.6406 10.1405 16.9797 10 17.3333 10H21.3333C21.5101 10 21.6797 10.0702 21.8047 10.1953C21.9298 10.3203 22 10.4899 22 10.6667V20C22 20.1768 21.9298 20.3464 21.8047 20.4714C21.6797 20.5964 21.5101 20.6667 21.3333 20.6667H17.3333C16.9797 20.6667 16.6406 20.8071 16.3905 21.0572C16.1405 21.3072 16 21.6464 16 22C16 21.6464 15.8595 21.3072 15.6095 21.0572C15.3594 20.8071 15.0203 20.6667 14.6667 20.6667Z",
    stroke: "#4C4C4C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11.3334V22",
    stroke: "#4C4C4C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6641 12.6666H13.3307",
    stroke: "#4C4C4C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6641 15.3334H13.3307",
    stroke: "#4C4C4C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6641 12.6666H19.3307",
    stroke: "#4C4C4C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6641 15.3334H19.3307",
    stroke: "#4C4C4C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6641 18H19.3307",
    stroke: "#4C4C4C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1184_1569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedger);
export default __webpack_public_path__ + "static/media/ledger.dccaea85b934bcf4c0742e9ca243a969.svg";
export { ForwardRef as ReactComponent };